module.exports = __webpack_public_path__ + "h5/img/bs_14.cc37d730.jpeg";